import {useCallback} from 'react'
import {useSelector} from 'react-redux'
import {getOfferCheckRoomsHeaders} from 'modules/accommodation/selectors'
import {
  roomOfferToOfferCheckParams,
  splitBookingOfferToOfferCheckParams
} from 'modules/accommodation/utils'
import {getCommonPaymentPageLandingParams} from 'modules/searchApi/selectors'
import Settings from 'Settings'

import {useBrand} from '@daedalus/core/src/_web/brand/hooks/useBrand'
import {parseUrl} from '@daedalus/core/src/_web/utils/url'
import {
  buildOfferCheckEndpoint,
  OfferCheckedIn
} from '@daedalus/core/src/offer/business/buildOfferCheckEndpoint'
import {getLinkByType} from '@daedalus/core/src/offer/business/getLinkByType'
import {getOfferCheckApiRequestParams} from '@daedalus/core/src/offer/business/getOfferCheckApiRequestParams'
import {ActionLinkTypes} from '@daedalus/core/src/offer/types/actionLink'
import {Offer} from '@daedalus/core/src/offer/types/offer'
import {SplitBooking} from '@daedalus/core/src/room/types/room'
import {BaseUrlCheckoutParams} from '@daedalus/core/src/utils/url/types/UrlParams'

export const useGetComposedOfferCheckAPIParamsBuilder = () => {
  const headers = useSelector(getOfferCheckRoomsHeaders)
  const commonPaymentPageParams = useSelector(getCommonPaymentPageLandingParams)
  const {brandCode} = useBrand()

  const buildOfferCheckParams = useCallback(
    ({offer, splitBooking}: {offer?: Offer; splitBooking?: SplitBooking}) => {
      if (!offer && !splitBooking) return null

      const links = offer?.links ?? splitBooking?.links
      const checkoutUrl = getLinkByType(links, ActionLinkTypes.CHECKOUT)
      const {searchObject} = parseUrl(checkoutUrl)
      const offerParams = offer
        ? roomOfferToOfferCheckParams(offer)
        : splitBookingOfferToOfferCheckParams(splitBooking)
      const env = Settings.get('APP_ENV')
      const offerCheckUrl = buildOfferCheckEndpoint(
        {
          ...commonPaymentPageParams,
          ...offerParams,
          ...(searchObject as BaseUrlCheckoutParams),
          offerCheckedIn: OfferCheckedIn.AP_OFFER_CLICK
        },
        Settings.get('CLIENT_BOVIO_ENDPOINT')
      )

      return getOfferCheckApiRequestParams(
        offerCheckUrl,
        brandCode,
        env,
        headers
      )
    },
    [brandCode, headers, commonPaymentPageParams]
  )

  return {buildOfferCheckParams}
}
